import { useState, useCallback, useEffect } from 'react';
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

export const useServiceWorker = () => {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);
  const [showReload, setShowReload] = useState<boolean>(false); // called when a service worker
  // updates. this function is a callback
  // to the actual service worker
  // registration onUpdate.
  const onSWUpdate = useCallback((registration: ServiceWorkerRegistration) => {
    if (!registration.waiting) {
      return;
    } // if there is a waiting service worker,
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  }, []); // simply put, this tells the service
  // worker to skip the waiting phase. The page reload itself is handled in
  // App.js on the `controllerchange` event, so we must NOT reload here.
  const reloadPage = useCallback(() => {
    console.log('Reloading page');
    // waitingWorker can be null if called before an update was detected.
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    setShowReload(false);
  }, [waitingWorker]); // register the service worker
  useEffect(() => {
    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://cra.link/PWA
    serviceWorkerRegistration.register({
      onUpdate: onSWUpdate,
    });

    // onUpdate only fires via registration.onupdatefound, which won't fire for
    // a worker that was already in the "waiting" state when this page loaded
    // (installed on a previous visit but never activated). Without this check
    // the user would be stuck on the old version with no update prompt, so look
    // for an existing waiting worker on mount and surface it.
    if ('serviceWorker' in navigator && navigator.serviceWorker) {
      navigator.serviceWorker
        .getRegistration()
        .then((registration) => {
          // Require an existing controller: App.js only reloads on
          // controllerchange when hadController was true. With no controller
          // (e.g. after a shift-reload that bypasses the SW) the prompt would
          // post SKIP_WAITING but App.js would never reload — a dead-end prompt.
          if (registration && registration.waiting && navigator.serviceWorker.controller) {
            setShowReload(true);
            setWaitingWorker(registration.waiting);
          }
        })
        .catch(() => {
          /* non-fatal: no registration / unsupported */
        });
    }
  }, [onSWUpdate]);
  return { showReload, waitingWorker, reloadPage };
};
